import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import Button from 'src/common/components/ButtonDS22';
import ButtonGroup from 'src/common/components/ButtonGroup';
import Modal from 'src/common/components/Modal';
import styles from 'src/admin/common/styles/BaseModal.module.scss';

type Props = {
  open: boolean;
  selectedListingsCount: number;
  closeModal: () => void;
  handleDelete: () => void;
};
const DeleteModal: FC<Props> = ({
  open, closeModal, handleDelete, selectedListingsCount,
}) => {
  const [t] = useTranslation('admin-listings');
  return (
    <Modal
      modalOpen={open}
      closeModal={closeModal}
      label={t('landing-page--delete-listing-title')}
      className={styles.root}
    >
      <Modal.Header>
        <Modal.Title>
          {t('landing-page--delete-listing-title')}
        </Modal.Title>
        <Modal.Description>
          {t('landing-page--delete-listing-subtitle', { count: selectedListingsCount })}
        </Modal.Description>
      </Modal.Header>
      <Modal.Footer>
        <ButtonGroup classNameModifier="centered">
          <Button variant="secondary" onClick={closeModal}>{t('landing-page--cancel')}</Button>
          <Button onClick={handleDelete}>{t('landing-page--delete')}</Button>
        </ButtonGroup>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
